import { mount } from '../dom-lifecycle';
import { openModal } from '../modal';

/*
	Bąbelki „?” przy polach dowodu zakupu otwierają modal ze zdjęciem paragonu,
	na którym podświetlone jest szukane pole. Markup: templates/_partials/paragon-modal.html.twig,
	style: components/pp-modal.scss.

	Otwieranie i zamykanie obsługuje wspólny `js/modal.js` (przyciemnienie, Escape,
	blokada przewijania). Tutaj zostaje tylko to, co swoiste: wybór właściwej grafiki.
	Wszystkie cztery siedzą w modalu naraz, przełączamy `hidden` — nie ma migania przy
	pierwszym otwarciu i nie trzeba budować URL-i assetów w JS.
*/

const MODAL = '[data-modal="paragon"]';

mount('[data-receipt-hint]', (button) => {
    button.addEventListener('click', () => {
        const modal = document.querySelector(MODAL);
        if (!modal) return;

        let found = false;
        modal.querySelectorAll('[data-paragon-hint]').forEach((image) => {
            const matches = image.dataset.paragonHint === button.dataset.receiptHint;
            image.hidden = !matches;
            found = found || matches;
        });
        if (!found) return;

        openModal(modal);
    });
});
